export interface ErrorResponse {
  uniqueId?: string,
  category: ErrorCodeCategory,
  errorCodeNumber?: number,
  cause: ErrorCause,
  message: string
}

export function isErrorResponse(error: object): error is ErrorResponse {
  return (error as ErrorResponse).message !== undefined;
}

export enum ErrorCodeCategory {
  ClientError = 400,
  ServerError = 500,
  Unknown = 600
}

export enum ErrorCause {
  ParseError = 'ParseError',
  AuthenticationError = 'AuthenticationError',
  ValidationError = 'ValidationError',
  NotFoundError = 'NotFoundError',
  PermissionDenied = 'PermissionDenied',
  UnknownError = 'UnknownError',
  RetryLaterError = 'RetryLaterError'
}

export function GetErrorCause(response: Response): ErrorCause {
  switch (response.status) {
    case 400: // Bad Request
      return ErrorCause.ValidationError;
    case 401: // Unauthorized
      return ErrorCause.AuthenticationError;
    case 403: // Forbidden
      return ErrorCause.PermissionDenied;
    case 404: // Not Found
      return ErrorCause.NotFoundError;
    case 422: // Unprocessable Entity
      return ErrorCause.ValidationError;
    case 408:
    case 425:
    case 429:
    case 503:
    case 504:
      return ErrorCause.RetryLaterError;
    default:
      return ErrorCause.UnknownError;
  }
}
